/**------------------------------------------------------
 * RxJs Object
 * -----------
 * ...
 */
export class RxJsObject {
	// ...
}
